'use es6';

import { fixCrossObjectReportId } from './pending/fixCrossObjectReportId';
export const migrations = {
  // shame migrations
  fixCrossObjectReportId
};